<div class="box">
  <div class="box-row header">
    <app-header-bar [title]="'device.title'"></app-header-bar>
    <p-message severity="info" styleClass="mt-3 w-100">
      <div class="d-flex flex-row justify-content-start gap-2">
        <span class="material-symbols-outlined" [ngClass]="'h4'">info</span>
        <div>
          <h4>{{ 'device.warning_title' | translate }}</h4>
          <p>{{ 'device.warning_text' | translate }}</p>
        </div>
      </div>
    </p-message>
    @if (hasChildOrganizations) {
      <div class="device-organization-filter mt-3">
        <label class="form-label" for="device-organization-filter">
          {{ 'device.organizationFilter' | translate }}
        </label>
        <p-select
          inputId="device-organization-filter"
          [options]="organizations"
          [(ngModel)]="selectedOrganizationId"
          optionValue="id"
          optionLabel="name"
          [filter]="true"
          filterBy="name"
          [filterPlaceholder]="'search' | translate"
          class="w-100"
        />
      </div>
    }
    <app-error [error]="error"></app-error>
  </div>
  <div class="content mt-2 mb-3">
    @if (selectedOrganizationId) {
      <app-reusable-tabs [tabConfig]="tabsConfig"> </app-reusable-tabs>
    }

    <ng-template #scannerTemplate>
      <app-scanner [organizationId]="organizationFilterId"></app-scanner>
    </ng-template>

    <ng-template #lighttagTemplate>
      <app-lighttag [organizationId]="organizationFilterId"></app-lighttag>
    </ng-template>

    <ng-template #mdmTemplate>
      <app-mdm [organizationId]="organizationFilterId"></app-mdm>
    </ng-template>
  </div>
</div>
